if (!window.FCTFeaturedProductMediaLayout) {
  window.FCTFeaturedProductMediaLayout = (() => {
    const thumbnailLayout = 'thumbnails';
    const layouts = ['grid', 'list', 'collage', thumbnailLayout];

    const normaliseLayout = (value, fallback = 'grid') => {
      return layouts.includes(value) ? value : fallback;
    };

    const replaceSlider = (slider, tagName) => {
      if (!slider || slider.tagName.toLowerCase() === tagName) return slider;

      if (slider.flkty && typeof slider.flkty.destroy === 'function') {
        slider.flkty.destroy();
      }

      const replacement = document.createElement(tagName);
      Array.from(slider.attributes).forEach((attribute) => {
        replacement.setAttribute(attribute.name, attribute.value);
      });
      while (slider.firstChild) replacement.appendChild(slider.firstChild);
      slider.replaceWith(replacement);
      return replacement;
    };

    const mount = (root) => {
      if (root.__featuredProductMediaLayout?.refresh) {
        root.__featuredProductMediaLayout.refresh();
        return;
      }

      const desktopLayout = normaliseLayout(root.dataset.desktopMediaLayout);
      const mobileLayout = normaliseLayout(root.dataset.mobileMediaLayout, desktopLayout);
      let activeLayout = null;

      const update = (force = false) => {
        const nextLayout = window.matchMedia('(min-width: 1068px)').matches ? desktopLayout : mobileLayout;
        if (!force && nextLayout === activeLayout) return;

        const slider = root.querySelector('.product-images');
        if (!slider) return;
        const nextTagName = nextLayout === thumbnailLayout ? 'product-slider-thumbnails' : 'product-slider';
        const nextSlider = replaceSlider(slider, nextTagName);

        nextSlider.classList.remove(...layouts.map((layout) => `product-images--${layout}`));
        nextSlider.classList.add(`product-images--${nextLayout}`);
        root.dataset.activeMediaLayout = nextLayout;
        activeLayout = nextLayout;
      };

      update();
      const mediaQuery = window.matchMedia('(min-width: 1068px)');
      mediaQuery.addEventListener('change', update);
      root.__featuredProductMediaLayout = {
        refresh: () => update(true)
      };
    };

    const mountAll = () => {
      document.querySelectorAll('.featured-product[data-desktop-media-layout][data-mobile-media-layout]').forEach(mount);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', mountAll, { once: true });
    } else {
      mountAll();
    }

    return { mount, mountAll };
  })();
}
